import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import ReactSelect from './ReactSelect';

const SelectHookForm = ({ defaultValue, name, options, rules, isLoading, ...props }) => {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    const defaultValueOption = options.find(option => option.value === defaultValue);
    // set default as value after loading options is done
    if (defaultValueOption && !isLoading) {
      setValue(name, defaultValueOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue, defaultValue]);

  const errorMessage = errors?.[name]?.message;

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value, name, onBlur } }) => (
        <ReactSelect
          errorMessage={errorMessage}
          onBlur={onBlur}
          onChange={onChange}
          options={options}
          value={value}
          name={name}
          {...props}
        />
      )}
    />
  );
};

SelectHookForm.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  name: PropTypes.string.isRequired,
  rules: PropTypes.any,
  options: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
};

SelectHookForm.defaultProps = {
  defaultValue: undefined,
  rules: undefined,
  isLoading: false,
};

export default SelectHookForm;
